import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { getIn } from 'formik'

import ItemForm from '../../../../Facebook/AdForms/AdFacebookCreate/AdFacebookCreateForm/Steps/ItemForm'
import ItemMediaFields from '../../ItemMediaFields'

import { keys } from '../../../../../helpers/common'

import { adCarouselSelectedIndexesSelector } from '../../../../../modules/selectors/ads'

import {
  AD_PREVIEW_CAROUSEL_INDEX_KEY,
  CAROUSEL_ITEM_MEDIA_FILE_ERROR,
  CAROUSEL_ITEMS,
  IS_ITEM_FORM_OPENED
} from '../../../../Facebook/AdForms/fields'

const CarouselItemForm = ({ formik, index, deleteItem, onItemClick, isStepFieldsValid, campaignObjective }) => {
  const selectedItemIndexes = useSelector(adCarouselSelectedIndexesSelector)

  const { values, setFieldValue, errors, touched } = formik

  const selectedItemIndexKey = values[AD_PREVIEW_CAROUSEL_INDEX_KEY]
  const selectedItemIndex = selectedItemIndexes[selectedItemIndexKey] || 0

  // Constant that represent path ot item in formik values
  const itemPath = `${CAROUSEL_ITEMS}[${index}]`

  const itemErrors = getIn(errors, itemPath)
  const itemTouched = getIn(touched, itemPath)
  const carouselItems = getIn(values, `${CAROUSEL_ITEMS}`)
  const mediaFileError = getIn(values, `${itemPath}.${CAROUSEL_ITEM_MEDIA_FILE_ERROR}`)
  const allowFormOpen = getIn(values, `${IS_ITEM_FORM_OPENED}`)
  const isItemActive = selectedItemIndex === index

  // isStepFieldsValid function from useStepForm hook for item validation
  const isStepValid = () => (isStepFieldsValid ? isStepFieldsValid(itemErrors, keys(itemTouched)) : true)
  const isValid = itemErrors && itemTouched && isStepValid()

  const isRemovable = carouselItems.length > 1

  const isOpened = isItemActive && allowFormOpen

  const handleDeleteCarouselItem = useCallback(() => {
    deleteItem(index)
  }, [index, deleteItem])

  const closeFormHandler = useCallback(() => {
    setFieldValue(IS_ITEM_FORM_OPENED, false)
  }, [setFieldValue])

  const selectCarouselForm = useCallback(() => {
    onItemClick({ index, isFormOpened: true })
  }, [onItemClick, index])

  return (
    <ItemForm
      mediaFileError={mediaFileError}
      isValid={isValid}
      isItemActive={isItemActive}
      isRemovable={isRemovable}
      index={index}
      isOpened={isOpened}
      deleteItem={handleDeleteCarouselItem}
      closeForm={closeFormHandler}
      selectForm={selectCarouselForm}
    >
      <ItemMediaFields formik={formik} itemPath={itemPath} campaignObjective={campaignObjective} />
    </ItemForm>
  )
}

CarouselItemForm.propTypes = {
  formik: PropTypes.object,
  item: PropTypes.object,
  index: PropTypes.number,
  deleteItem: PropTypes.func,
  onItemClick: PropTypes.func,
  showErrors: PropTypes.bool,
  isStepFieldsValid: PropTypes.func
}

export default CarouselItemForm
